import getEmbeddedApiConfigurationState from './getEmbeddedApiConfigurationState.js';

const getEmbeddedIntegrationRoute = (integration) => {
  if (getEmbeddedApiConfigurationState(integration) === 'automatic') {
    return `/embedded/connections?appId=${encodeURIComponent(integration.appId)}`;
  }
  return `/embedded/${integration.id}`;
};

export default getEmbeddedIntegrationRoute;
